module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"Fecha lanzamiento":"Fecha lanzamiento"},"en":{},"ca":{"Fecha lanzamiento":"Data de llançament"}}')
  delete Component.options._Ctor
}
